import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';

const routes = [...dashboard.routes];

export const router = createRouter({ history: createWebHistory(), routes });

const isEnabledSetting = value => value === true || value === 'true';

const accountForRoute = (user, accountId) => {
  const accountIdNumber = Number(accountId);
  const userAccount = (user.accounts || []).find(
    account => account.id === accountIdNumber
  );

  if (!userAccount) return null;

  const accountFromStore =
    store.getters['accounts/getAccount']?.(accountIdNumber) || {};
  const storeSettings = accountFromStore.settings || {};
  const storeHasEssentialFlag = Object.prototype.hasOwnProperty.call(
    storeSettings,
    'essential_interface_enabled'
  );
  const essentialInterfaceEnabled = storeHasEssentialFlag
    ? storeSettings.essential_interface_enabled
    : userAccount.essential_interface_enabled;

  return {
    ...accountFromStore,
    ...userAccount,
    essential_interface_enabled: isEnabledSetting(essentialInterfaceEnabled),
  };
};

const canUseEssential = account => {
  if (!account?.essential_interface_enabled) return false;
  return (
    account.role === 'administrator' || account.interface_mode === 'essential'
  );
};

const shouldDefaultToEssential = account => {
  if (!account?.essential_interface_enabled) return false;
  return (
    account.role !== 'administrator' && account.interface_mode === 'essential'
  );
};

const accountHomeURL = (accountId, user) => {
  const account = accountForRoute(user, accountId);
  const homePath = shouldDefaultToEssential(account)
    ? 'essential'
    : 'dashboard';
  return frontendURL(`accounts/${accountId}/${homePath}`);
};

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    window.location.assign('/app/login');
    return '';
  }

  const { accounts = [], account_id: accountId } = user;

  if (!accounts.length) {
    if (to.name === 'no_accounts') {
      return next();
    }
    return next(frontendURL('no-accounts'));
  }

  if (to.name === 'no_accounts' || !to.name) {
    return next(accountHomeURL(accountId, user));
  }

  const routeAccountId = to.params?.accountId || accountId;
  const routeAccount = accountForRoute(user, routeAccountId);

  if (to.name === 'home' && shouldDefaultToEssential(routeAccount)) {
    return next(frontendURL(`accounts/${routeAccountId}/essential`));
  }

  if (
    String(to.name || '').startsWith('essential') &&
    !canUseEssential(routeAccount)
  ) {
    return next(frontendURL(`accounts/${routeAccountId}/dashboard`));
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, _from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
